import { Newspaper } from "lucide-react";
import { Link } from "react-router-dom";

import { cn } from "@/shared/lib/utils";

import type { NewsStatus } from "../../../api/flowTypes";
import { sitePath } from "../../../model/siteStep";

/** 新闻舱首页(官网栏目在那管)。 */
export const NEWS_MANAGE_PATH = "/ai-jizhe";

/**
 * 「新闻自动更新:未开启 → 去开启 / 已开启 · 每天 1 篇 → 管理」(站点卡 / 预览调整页 / 上线页共用)。
 * 老后端没给 `newsStatus`(undefined)时不画 —— 不知道就别说「未开启」。
 */
export function NewsStatusEntry({
  siteId,
  status,
  className,
}: {
  siteId: string;
  status: NewsStatus | null | undefined;
  className?: string;
}) {
  if (status === undefined) return null;
  const on = status?.state === "enabled";
  return (
    <p
      className={cn("flex flex-wrap items-center gap-1.5 text-xs", className)}
      data-news-status={on ? "on" : "off"}
    >
      <Newspaper className="h-3.5 w-3.5 text-muted-foreground" aria-hidden />
      <span className="text-muted-foreground">新闻自动更新:</span>
      {on ? (
        <>
          <span className="text-foreground">已开启{status?.label ? ` · ${status.label}` : ""}</span>
          <Link to={NEWS_MANAGE_PATH} className="text-primary hover:underline">
            管理
          </Link>
        </>
      ) : (
        <>
          <span className="text-foreground">
            {status?.state === "disabled" ? "已暂停" : "未开启"}
          </span>
          <Link
            to={sitePath(siteId, "launch")}
            state={{ from: "/ai-website" }}
            className="text-primary hover:underline"
          >
            {status?.state === "disabled" ? "去恢复" : "去开启"}
          </Link>
        </>
      )}
    </p>
  );
}
